import React from "react"

import { Element, ElementProps } from "legacy/components/shared/base"

export type OwnProps = {
  title: string
  titleSize: string
}

export type TitleProps = OwnProps & ElementProps

export const Title: React.FC<TitleProps> = ({
  title,
  titleSize,
  ...elementProps
}): React.ReactElement | null => {
  if (!title) {
    return null
  }

  let titleFontSize
  let titleLineHeight
  switch (titleSize) {
    case "Extra Large":
      titleFontSize = ["36", "72"]
      titleLineHeight = ["44px", "80px"]
      break
    case "Large Title":
      titleFontSize = ["36", "72"]
      titleLineHeight = ["44px", "80px"]
      break
    case "Large Title 2":
      titleFontSize = ["36", "62"]
      titleLineHeight = ["44px", "70px"]
      break
    case "Title 1":
      titleFontSize = ["28", "44"]
      titleLineHeight = ["34px", "56px"]
    case "Large":
      titleFontSize = ["28", "44"]
      titleLineHeight = ["34px", "56px"]
      break
    case "Title 2":
      titleFontSize = ["25", "32"]
      titleLineHeight = ["31px", "40px"]
    default:
      titleFontSize = ["25", "32"]
      titleLineHeight = ["31px", "40px"]
      break
  }

  return (
    <Element
      color="offBlack"
      fontFamily="prospectus"
      fontSize={titleFontSize}
      fontWeight="700"
      lineHeight={titleLineHeight}
      {...elementProps}
    >
      {title}
    </Element>
  )
}
